import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="py-12 px-6 lg:px-12 border-t border-[#D4AF37]/10 bg-[#050505]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-lg flex items-center justify-center">
              <span className="brand-font font-bold text-xl text-black">23</span>
            </div>
            <span className="brand-font font-bold text-xl text-[#D4AF37]">23madethis</span>
          </div>
          <div className="flex items-center gap-6 text-neutral-500 text-sm">
            <Link to="/beats" className="hover:text-[#D4AF37] transition-colors">Beats</Link>
            <Link to="/services" className="hover:text-[#D4AF37] transition-colors">Services</Link>
            <span>© 2025 23madethis</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
